"use client";

import { useEffect, useState } from "react";
import CityPriceGridClient, { CityPriceGridCity } from "./CityPriceGridClient";

// EmiCalculatorPageClient dispatches this on `window` whenever the user picks
// a different variant, so this component can stay positioned wherever the
// page layout wants it (matching sibling PDP pages) instead of being nested
// inside the calculator's own component tree.
export const EMI_SELECTED_VARIANT_EVENT = "emi-selected-variant-changed";

/** Fired when EMI calculator sliders / on-road price change (loan, rate, tenure, etc.). */
export const EMI_CALCULATOR_METRICS_EVENT = "emi-calculator-metrics-changed";

export type EmiCalculatorMetricsDetail = {
    emi: number;
    loanMonths: number;
    effectivePrice: number;
    interestRate: number;
    downPayment: number;
    loanAmount: number;
};

export default function CityPriceGridReactive({
    title,
    subtitle,
    initialVariant = null,
    brandSlug = "",
    modelSlug = "",
    cities = [],
}: {
    title?: string;
    subtitle?: string;
    initialVariant?: any | null;
    brandSlug?: string;
    modelSlug?: string;
    cities?: CityPriceGridCity[];
}) {
    const [variant, setVariant] = useState<any | null>(initialVariant);

    useEffect(() => {
        const handler = (e: Event) => {
            const detail = (e as CustomEvent).detail;
            if (detail) setVariant(detail);
        };
        window.addEventListener(EMI_SELECTED_VARIANT_EVENT, handler);
        return () => window.removeEventListener(EMI_SELECTED_VARIANT_EVENT, handler);
    }, []);

    return (
        <CityPriceGridClient
            title={title}
            subtitle={subtitle}
            variantData={variant}
            brandSlug={brandSlug}
            modelSlug={modelSlug}
            cities={cities}
        />
    );
}
